import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import editorialPhotographyImg from './images/editorial-photography.png';
import fineArtImg from './images/fine-art.png';
import glamourCollectionsImg from './images/glamour-collections.png';
import artisticStorytellingImg from './images/artistic-storyteling.png';
import premiumVisualContentImg from './images/premium-visual-content.png';
import exclusiveCreatorImg from './images/exclusive-creator.png';

const useStyles = makeStyles((theme) => ({
  section: {
    maxWidth: '1314px',
    margin: '0 auto',
    padding: '0 0px',
    textAlign: 'center',
    marginBottom: '70px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '45px',
      padding: '0 20px',
    }
  },
  sectionTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    lineHeight: '100%',
    marginBottom: '16px',
    color: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
    }
  },
  sectionSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    color: 'rgba(255, 255, 255, 0.65)',
    lineHeight: "27px",
    fontWeight: 200,
    marginBottom: '32px',
    maxWidth: '780px',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
      marginBottom: '32px',
      maxWidth: '280px',
      fontWeight: "200 !important",
    }
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '30px',
    marginBottom: '48px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '24px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '24px',
    }
  },
  card: {
    position: 'relative',
    width: '100%',
    height: '280px',
    borderRadius: '16px 16px 0 0',
    overflow: 'hidden',
    backgroundColor: '#111111',
    cursor: 'pointer',
    '&:hover $cardImage': {
      transform: 'scale(1.08)',
    },
    '&:hover $cardDesc': {
      opacity: 1,
      maxHeight: '100px',
      transform: 'translateY(0)',
      marginTop: '6px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '390px',
      height: '246px',
      borderRadius: '12px 12px 0 0',
      margin: '0 auto',
    },
    '@media (max-width: 400px)': {
      maxWidth: '348px',
      height: '220px',
    }
  },
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.4s ease',
    display: 'block',
  },
  cardOverlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: '24px 22px 20px',
    background: 'linear-gradient(180deg, rgba(17, 17, 17, 0) 0%, rgba(17, 17, 17, 0) 20%, rgba(17, 17, 17, 0.55) 45%, rgba(17, 17, 17, 0.92) 70%, #111111 88%, #111111 100%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '16px 18px 14px',
      background: 'linear-gradient(180deg, rgba(17, 17, 17, 0) 0%, rgba(17, 17, 17, 0) 20%, rgba(17, 17, 17, 0.55) 45%, rgba(17, 17, 17, 0.92) 70%, #111111 88%, #111111 100%)',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px 18px 14px',
      background: 'linear-gradient(180deg, rgba(17, 17, 17, 0) 0%, rgba(17, 17, 17, 0) 20%, rgba(17, 17, 17, 0.55) 45%, rgba(17, 17, 17, 0.92) 70%, #111111 88%, #111111 100%)',
    }
  },
  cardTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '24px',
    fontWeight: 500,
    color: '#ffffff',
    textAlign: 'left',
    lineHeight: '100%',
    letterSpacing: '0%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeight: '100%',
      letterSpacing: '0%',
      marginBottom: '8px'
    }
  },
  cardDesc: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    fontWeight: 200,
    color: '#FFFFFF',
    lineHeight: '27px',
    letterSpacing: '0%',
    textAlign: 'left',
    opacity: 0,
    maxHeight: 0,
    transform: 'translateY(12px)',
    transition: 'all 0.35s ease',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      fontWeight: 200,
      color: '#FFFFFF',
      lineHeight: '24px',
      letterSpacing: '0%',
      opacity: 1,
      maxHeight: '100px',
      transform: 'translateY(0)',
      marginTop: '0px',
    }
  },
  btnWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '16px',
  },
  requestAccessBtn: {
    color: '#ffffff',
    border: '1px solid transparent',
    borderRadius: '6px',
    background: 'linear-gradient(#161616, #161616) padding-box, linear-gradient(90deg, #87959C 1.44%, #89959C 7.69%, #8B949B 13.94%, #B1B3BB 21.15%, #C3C8CC 31.25%, #F1F2F4 38.94%, #D2DBE6 51.44%, #D2DBE6 63.46%, #9AB0B7 81.73%, #A5B7C0 94.71%) border-box',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: 600,
    fontFamily: '"Roboto", sans-serif',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      background: 'linear-gradient(#222222, #222222) padding-box, linear-gradient(90deg, #87959C 1.44%, #89959C 7.69%, #8B949B 13.94%, #B1B3BB 21.15%, #C3C8CC 31.25%, #F1F2F4 38.94%, #D2DBE6 51.44%, #D2DBE6 63.46%, #9AB0B7 81.73%, #A5B7C0 94.71%) border-box',
      transform: 'translateY(-1px)',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: '300px',
    }
  }
}));

const COLLECTIONS = [
  {
    title: "Editorial Photography",
    desc: "Magazine-grade shoots built around light, composition, and story.",
    image: editorialPhotographyImg,
  },
  {
    title: "Fine Art",
    desc: "Considered, gallery-worthy work beyond the ordinary feed.",
    image: fineArtImg,
  },
  {
    title: "Glamour Collections",
    desc: "Classic glamour styling with a modern, elevated finish.",
    image: glamourCollectionsImg,
  },
  {
    title: "Artistic Storytelling",
    desc: "Full bodies of work, organized like a personal exhibition.",
    image: artisticStorytellingImg,
  },
  {
    title: "Premium Visual Content",
    desc: "Concept-driven sets that unfold like a narrative, not a post.",
    image: premiumVisualContentImg,
  },
  {
    title: "Exclusive Creator Galleries",
    desc: "The highest tier of production quality on the platform, curated by hand.",
    image: exclusiveCreatorImg,
  },
];

export const FineArtExperiencesSection = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.section}>
      <Typography className={classes.sectionTitle}>
        Premium Collections
      </Typography>
      <Typography className={classes.sectionSubtitle}>
        A gallery of the visual work our creators are known for — framed the way it deserves to be seen.
      </Typography>

      <Box className={classes.grid}>
        {COLLECTIONS.map((item, index) => (
          <Box
            key={index}
            className={classes.card}
          // onClick={() => history.push('/login')}
          >
            <img
              src={item.image}
              alt={item.title}
              className={classes.cardImage}
            />
            <Box className={classes.cardOverlay}>
              <Typography className={classes.cardTitle}>
                {item.title}
              </Typography>
              {item.desc && (
                <Typography className={classes.cardDesc}>
                  {item.desc}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Box>

      <Box className={classes.btnWrapper}>
        <button
          className={classes.requestAccessBtn}
          onClick={() => history.push('/member-onboarding-step')}
        >
          Request Member Access
        </button>
      </Box>
    </Box>
  );
};
